import { Route, Routes, useNavigate } from 'react-router-dom'
import React, { lazy } from 'react'
import { useAppSelector } from '../hooks'
import { permissionsUser } from '../store/selectors'
import { ROUTES } from './const'

const EmergencyPage = lazy(() => import('pages/EmergencyPage'))
const NewEmergencyReport = lazy(() => import('../pages/EmergencyPage/components/NewEmergencyReport'))
const EmergencyPlanProfile = lazy(() => import('../pages/EmergencyPage/components/EmergencyPlanProfile'))
const NewEmergencyPlan = lazy(() => import('../pages/EmergencyPage/components/NewEmergencyPlan'))

const EmergencyRoutes = () => {
    const navigate = useNavigate()
    const { isSuperAdmin } = useAppSelector(permissionsUser)

    if (isSuperAdmin) {
        navigate(ROUTES.DASHBOARD)
    }
    return (
        <Routes>
            <Route index element={<EmergencyPage />} />
            <Route path="/new-plan" element={<NewEmergencyPlan />} />
            <Route path="/new-report" element={<NewEmergencyReport />} />
            <Route path="/:id" element={<EmergencyPlanProfile />} />
        </Routes>
    )
}

export default EmergencyRoutes
